import template from './cashbox-transfers.html';
import controller from './cashbox-transfers.controller';

const CashboxTransfersComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default CashboxTransfersComponent;
